import { createContext, useContext } from 'react';
const SessionContext = createContext();
export default SessionContext;
export const SessionProvider = SessionContext.Provider;
export const useSession = () => useContext(SessionContext);